"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    playing: false
};
function animationPlayReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.SET_PLAY_ANIMATION_VALUE:
            return {
                playing: action.payload.playing
            };
        case types_1.RESET_PLAY_ANIMATION_VALUE:
            return initialState;
        default:
            return state;
    }
}
exports.animationPlayReducer = animationPlayReducer;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/animation-playing/reducers.ts
// module id = 2416
// module chunks = 5